import React from "react";
import { Icon } from "@chakra-ui/react";
import { MdHome, MdGroup, MdLock, MdListAlt, MdChecklistRtl, MdComment, MdReportGmailerrorred, MdShoppingCartCheckout, MdBrowserUpdated, MdOutlineConnectWithoutContact, MdHowToReg, MdRecommend } from "react-icons/md";
import { MdSupportAgent } from "react-icons/md";
import { IoIosPaper, IoIosPeople, IoMdLocate, IoMdWifi } from "react-icons/io";
import { TbPhoneCalling } from "react-icons/tb";
import { VscFeedback } from "react-icons/vsc";
import { FaDisplay, FaListCheck } from "react-icons/fa6";
import MainDashboard from "views/admin/default";
import UsersTable from "views/admin/users";
import PropertiesTable from "views/admin/properties";
import BuildersTable from "views/admin/builders";
import SignInCentered from "views/auth/signIn";
import Form from "views/admin/form/Form";
import AgentsTable from "views/admin/agents";
import JobApplications from "views/admin/jobs";
import LocalityInsight from "views/admin/localityInsight";
import PropertyStat from "views/admin/properties/propertyStat/PropertyStat";
import UserActivity from "views/admin/userActivity";
import CreateBuilder from "views/admin/builders/Form";
import ProjectTable from "views/admin/project";
import UserRequirements from "views/admin/userRequirements";
import BrokerGroups from "views/admin/brokerGroups";
import UserRequests from "views/admin/userRequests";
import UserFeedbacks from "views/admin/UserFeedbacks";
import UserReports from "views/admin/userReports";
import LocalityOverview from "views/admin/localityoverview";
import { GrMapLocation } from "react-icons/gr";
import { PiChartLineThin, PiUserListBold } from "react-icons/pi";
import DataCharts from "views/admin/dataCharts";
import Subscriptions from "views/admin/subscriptions";
import OrderListing from "views/admin/orderListing";
import Plans from "views/admin/plans";
import FeaturesListing from "views/admin/featuresListing";
import CreatePlan from "views/admin/plans/Form";
import UserUsage from "views/admin/userUsage";
import CreateFeatures from "views/admin/features/CreateFeatures";
import ViewNumberUsage from "views/admin/viewNumberUsage";
import SubscriptionForm from "views/admin/subscriptions/Form";
import DirectLeadsList from "views/admin/direct-leads";
import RecommendationList from "views/admin/recommendations";
import { FaCreditCard } from "react-icons/fa";
import PaymentList from "views/admin/payments";

const routes = [
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/default',
    icon: <Icon as={MdHome} width="30px" height="30px" color="inherit" />,
    component: MainDashboard,
    authorized: ['admin', 'marketing_admin'],
  },
    {
    name: 'Ads',
    layout: '/admin',
    path: '/ads',
    icon: <Icon as={FaDisplay} width="28px" height="24px" color="inherit" />,
    component: PropertiesTable,
    authorized: ['admin', 'marketing_admin', 'sales_admin'],
  },
   {
    name: 'Users',
    layout: '/admin',
    path: '/users',
    icon: <Icon as={MdGroup} width="30px" height="30px" color="inherit" />,
    component: UsersTable,
    authorized: ['admin', 'hr_admin', 'marketing_admin', 'sales_admin'],
  },
   {
    name: 'Locality Insights',
    layout: '/admin',
    path: '/locality-insights',
    icon: <Icon as={IoMdLocate} width="30px" height="30px" color="inherit" />,
    component: LocalityInsight,
    authorized: ['admin', 'sales_admin'],
  },
   {
    name: 'User Activity',
    layout: '/admin',
    path: '/user-activity',
    icon: <Icon as={IoMdWifi} width="30px" height="30px" color="inherit" />,
    component: UserActivity,
    authorized: ['admin', 'sales_admin'],
  },
  {
    name: 'User Request',
    layout: '/admin',
    path: '/user-requests',
    icon: <Icon as={MdComment} width="30px" height="30px" color="inherit" />,
    component: UserRequests,
    authorized: ['admin', 'sales_admin'],
  },
  {
    name: 'User Feedback',
    layout: '/admin',
    path: '/user-feedbacks',
    icon: <Icon as={VscFeedback} width="30px" height="30px" color="inherit" />,
    component: UserFeedbacks,
    authorized: ['admin'],
  },
  {
    name: 'User Requirement',
    layout: '/admin',
    path: '/user-requirements',
    icon: <Icon as={MdChecklistRtl} width="30px" height="30px" color="inherit" />,
    component: UserRequirements,
    authorized: ['admin', 'sales_admin'],
  },
  {
    name: 'Broker Groups',
    layout: '/admin',
    path: '/broker-groups',
    icon: <Icon as={MdListAlt} width="30px" height="30px" color="inherit" />,
    component: BrokerGroups,
    authorized: ['admin', 'sales_admin'],
  },
  {
    name: 'Direct Leads',
    layout: '/admin',
    path: '/direct-leads',
    icon: <Icon as={MdHowToReg} width="30px" height="30px" color="inherit" />,
    component: DirectLeadsList,
    authorized: ['admin', 'sales_admin'],
  },
  {
    name: 'Recommendations',
    layout: '/admin',
    path: '/recommendations',
    icon: <Icon as={MdRecommend} width="30px" height="30px" color="inherit" />,
    component: RecommendationList,
    authorized: ['admin', 'sales_admin'],
  },
   {
    name: 'Plan Listing',
    layout: '/admin',
    path: '/plan-list',
    icon: <Icon as={PiUserListBold} width="30px" height="30px" color="inherit" />,
    component: Plans,
    authorized: ['admin', 'sales_admin'],
  },
  {
    name: 'Features Listing',
    layout: '/admin',
    path: '/feature-list',
    icon: <Icon as={MdBrowserUpdated} width="30px" height="30px" color="inherit" />,
    component: FeaturesListing,
    authorized: ['admin'],
  },
  {
    name: 'Order Listing',
    layout: '/admin',
    path: '/order-listing',
    icon: <Icon as={MdShoppingCartCheckout} width="30px" height="30px" color="inherit" />,
    component: OrderListing,
    authorized: ['admin', 'sales_admin'],
  },
  {
    name: 'Subscriptions',
    layout: '/admin',
    path: '/subscriptions',
    icon: <Icon as={FaListCheck} width="30px" height="30px" color="inherit" />,
    component: Subscriptions,
    authorized: ['admin', 'sales_admin'],
  },
  {
    name: 'Payments',
    layout: '/admin',
    path: '/payments',
    icon: <Icon as={FaCreditCard} width="30px" height="30px" color="inherit" />,
    component: PaymentList,
    authorized: ['admin'],
  },
  {
    name: 'Plan Usage',
    layout: '/admin',
    path: '/user-usage',
    icon: <Icon as={MdOutlineConnectWithoutContact} width="30px" height="30px" color="inherit" />,
    component: UserUsage,
    authorized: ['admin', 'sales_admin'],
  },
  {
    name: 'View Number Usage',
    layout: '/admin',
    path: '/view-number-usage',
    icon: <Icon as={TbPhoneCalling} width="30px" height="30px" color="inherit" />,
    component: ViewNumberUsage,
    authorized: ['admin', 'sales_admin'],
  },
   {
    name: 'Data Charts',
    layout: '/admin',
    path: '/data-charts',
    icon: <Icon as={PiChartLineThin} width="30px" height="30px" color="inherit" />,
    component: DataCharts,
    authorized: ['admin'],
  },
    {
    name: 'Job Applications',
    layout: '/admin',
    path: '/job-applications',
    icon: <Icon as={IoIosPaper} width="30px" height="30px" color="inherit" />,
    component: JobApplications,
    authorized: ['admin', 'hr_admin'],
  },
  {
    name: 'Project',
    layout: '/admin',
    path: '/project',
    icon: <Icon as={IoIosPeople} width="30px" height="30px" color="inherit" />,
    component: ProjectTable,
    authorized: ['admin'],
  },
  {
    name: 'Agents',
    layout: '/admin',
    path: '/agents',
    icon: (
      <Icon as={MdSupportAgent} width="30px" height="30px" color="inherit" />
    ),
    component: AgentsTable,
    authorized: ['admin'],
  },
  {
    name: 'Builders',
    layout: '/admin',
    path: '/builders',
    icon: <Icon as={IoIosPeople} width="30px" height="30px" color="inherit" />,
    component: BuildersTable,
    authorized: ['admin'],
  },
  
  {
    name: 'Ads Stats',
    layout: '/admin',
    path: '/users/:userId',
    icon: <Icon as={FaDisplay} width="28px" height="24px" color="inherit" />,
    component: PropertyStat,
    authorized: ['admin'],
  },

  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width="30px" height="30px" color="inherit" />,
    component: SignInCentered,
    authorized: ['admin'],
  },
  {
    name: 'Dynamic Form',
    layout: '/admin',
    path: '/form',
    icon: <Icon as={MdLock} width="30px" heght="30px" color="inherit" />,
    component: Form,
    authorized: ['admin', 'marketing_admin', 'sales_admin'],
  },
  {
    name: 'Dynamic Builder Creation Form',
    layout: '/admin',
    path: '/builder',
    icon: <Icon as={MdLock} width="30px" heght="30px" color="inherit" />,
    component: CreateBuilder,
    authorized: ['admin'],
  },
   {
    name: 'Dynamic Plans Creation Form',
    layout: '/admin',
    path: '/plans',
    icon: <Icon as={MdLock} width="30px" heght="30px" color="inherit" />,
    component: CreatePlan,
    authorized: ['admin'],
  },
  {
    name: 'Subscription Form',
    layout: '/admin',
    path: '/subscription',
    icon: <Icon as={MdLock} width="30px" heght="30px" color="inherit" />,
    component: SubscriptionForm,
    authorized: ['admin'],
  },
  {
    name: 'Dynamic Features Creation Form',
    layout: '/admin',
    path: '/feature',
    icon: <Icon as={MdLock} width="30px" heght="30px" color="inherit" />,
    component: CreateFeatures,
    authorized: ['admin'],
  },
  {
    name: 'User Reports',
    layout: '/admin',
    path: '/user-reports',
    icon: <Icon as={MdReportGmailerrorred} width="30px" height="30px" color="inherit" />,
    component: UserReports,
    authorized: ['admin'],
  },
   {
    name: 'Locality Overview',
    layout: '/admin',
    path: '/locality-overview',
    icon: <Icon as={GrMapLocation} width="30px" height="30px" color="inherit" />,
    component: LocalityOverview,
    authorized: ['admin'],
  },
  
];

export default routes;
